export { QueryKeys } from "./queryKeys";
export { QueryTimes } from "./queryTimes";
import { isDevelopment } from "~/utils/env";

export const AUTH_TOKEN = "@biztrip.authtoken";

export const IS_DEVELOPMENT = isDevelopment();